<div class="pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3" *ngIf="serverError === null">
  <div class="row">
    <div class="col-xl-5 col-12 mb-3">
      <input type="text" class="form-control"
             placeholder="Filter members by email, name, barcode, and telephone"
             [(ngModel)]="filters.search"
             (ngModelChange)="this.filtersChangedSubject.next()">
    </div>
    <div class="col-xl-7 col-12 mb-3 clearfix"></div>
  </div>

  <div class="rounded-table-wrapper rounded-table-tight table-responsive">
    <table class="table table-hover table-12px">

      <thead>
      <tr>
        <th scope="col" colspan="99" class="text-primary" style="font-size: 16px; line-height: 16px; padding-top: 8px; padding-bottom: 8px;">
          <div class="float-right">
            <button class="btn btn-sm btn-outline-primary mr-2"
                    style="font-size: 12px; line-height: 12px;"
                    [class.disabled]="loadingMembers"
                    [disabled]="loadingMembers"
                    (click)="openAddMemberModal()">
              Add Association Member
            </button>
            <button class="btn btn-sm btn-outline-primary"
                    style="font-size: 12px; line-height: 12px;"
                    [class.disabled]="loadingMembers"
                    [disabled]="loadingMembers"
                    (click)="openBulkUploadMembersModal()">
              Bulk Upload
            </button>
          </div>
          <span style="position: relative; top: 4px;">Association Members</span>
        </th>
      </tr>
      <tr>
        <th scope="col">Name</th>
        <th scope="col">Birthday</th>
        <th scope="col">Added Date</th>
        <th scope="col"></th>
      </tr>
      </thead>

      <tbody *ngIf="!loadingMembers">
      <tr *ngFor="let member of memberList.results">
        <td>
          <a [routerLink]="['/customers', member.customer_id.toString()]">
            {{ member.customer_first_name }} {{ member.customer_last_name }}
            <span *ngIf="member.has_pending_application" class="text-warning">- Pending</span>
          </a>
        </td>
        <td class="text-nowrap">{{ dateStringFromISO8601(member.customer_birthday) }}</td>
        <td class="text-nowrap">{{ dateStringFromISO8601(member.created_at) }}</td>
        <td class="table-12px-button-cell">
          <ng-container *ngIf="!member.has_pending_application">
            <button class="btn btn-sm btn-outline-primary table-12px-button float-right" type="button"
                    (click)="handleEditMember(member)">
              Edit
            </button>
            <button class="btn btn-sm btn-outline-primary table-12px-button float-right mr-1" type="button"
                    [disabled]="loadingCheckInByMemberId[member.id]"
                    [class.disabled]="loadingCheckInByMemberId[member.id]"
                    (click)="checkInMemberInit(member)">
              Check In
            </button>
          </ng-container>
          <ng-container *ngIf="member.has_pending_application">
            <button class="btn btn-sm btn-outline-warning table-12px-button float-right" type="button"
                    (click)="handleReviewJoinRequest(member)">
              Review
            </button>
          </ng-container>
        </td>
      </tr>
      <tr *ngIf="memberList.results.length === 0">
        <td colspan="99" class="text-muted">No members</td>
      </tr>
      </tbody>

      <tbody *ngIf="loadingMembers">
      <tr>
        <td colspan="99" class="text-muted">Loading members...</td>
      </tr>
      </tbody>

    </table>
  </div>

  <div class="row">
    <div class="col-sm mb-2">
      <label for="resultsPerPage" class="pr-1 align-middle">
        Results per page:
      </label>
      <select id="resultsPerPage" class="form-control d-inline-block" style="width:80px;"
              [(ngModel)]="pageSizeAssociationMembersSubList" (change)="setPage(1)">
        <option [ngValue]="10">10</option>
        <option [ngValue]="25">25</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
      </select>
    </div>
    <div class="col-sm">
      <nav aria-label="Customer pagination">
        <ul class="pagination justify-content-end">
          <li class="page-item" [class.disabled]="pageNumber <= 1">
            <button class="page-link" aria-label="Previous"
                    [disabled]="pageNumber <= 1"
                    (click)="setPage(pageNumber - 1)">
              <span aria-hidden="true">&laquo;</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 2">
            <button class="page-link"
                    (click)="setPage(pageNumber - 2)">
              {{ pageNumber - 2 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 1">
            <button class="page-link"
                    (click)="setPage(pageNumber - 1)">
              {{ pageNumber - 1 }}
            </button>
          </li>
          <li class="page-item active" aria-current="page">
            <button class="page-link" disabled>
              {{ pageNumber }}
              <span class="sr-only">(current)</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < lastPageNumber()">
            <button class="page-link"
                    (click)="setPage(pageNumber + 1)">
              {{ pageNumber + 1 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < (lastPageNumber() - 1)">
            <button class="page-link"
                    (click)="setPage(pageNumber + 2)">
              {{ pageNumber + 2 }}
            </button>
          </li>
          <li class="page-item" [class.disabled]="pageNumber >= lastPageNumber()">
            <button class="page-link" aria-label="Next"
                    [disabled]="pageNumber >= lastPageNumber()"
                    (click)="setPage(pageNumber + 1)">
              <span aria-hidden="true">&raquo;</span>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>
